import React from "react";
import TSTable from "../common/TSTable";
import { Tooltip, DatePicker, Tag } from "antd";
import { URL_TRUCK } from "../constants/urls";
import * as _ from "lodash";
import {
  dateToHumanString,
  formatComma,
  getLabResultColor,
  timeToString,
  toFixed,
} from "../frameworks/Util";
import ErrorMessages from "../common/ErrorMessages";
import ReceivingWeightLogModal from "../components/receiving-latex/ReceivingWeightLogModal";
import SummaryWeightLatex from "../components/common/SummaryWeightLatex"
import dayjs from 'dayjs';
import { PATH } from "../routes/CustomRoutes";
import { GET } from "../frameworks/HttpClient";

const ReceivingLatexList = React.forwardRef((props, ref) => {
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [targetOutWeightLog, setTargetOutWeightLog] = React.useState(null);
  const [targetInWeightLog, setTargetInWeightLog] = React.useState(null);
  const [rangeDate , setRangeDate] = React.useState({date_after : dayjs().format('YYYY-MM-DD'), date_before : dayjs().format('YYYY-MM-DD')});
  const tableRef = React.useRef(null);

  const refreshData = async (params = {}) => {
    if (tableRef.current) await tableRef.current.fetch(params);
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "เที่ยวที่",
      dataIndex: "round_trip",
      key: "round_trip",
    },
    {
      title: "เลขที่บัตร",
      dataIndex: "code",
      key: "code",
      searcher: true,
    },
    {
      title: "รหัสผู้ขาย",
      dataIndex: "supplier_code",
      key: "supplier_code",
      searcher: true,
    },
    {
      title: "ทะเบียนรถ",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      searcher: true,
      render : (value, original) => 
      <Tooltip triger='hover' title={"ประวัติรถเข้าโรงงาน"}>
        <a onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${original.id}`)}>
          {value}
          {original.substitute_license_plate && <div style={{fontSize: '12px', color: '#666'}}>({original.substitute_license_plate})</div>}
        </a>
      </Tooltip>
    },
    {
      title: "เข้า",
      children: [
        {
          title: "วัน - เวลา",
          dataIndex: "in_datetime",
          key: "in_datetime",
          render: (value) => {
            return (
              <center>
                <div>{value ? dateToHumanString(value) : "-"}</div>
                <div>{value ? timeToString(value) : ""}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "in_weight",
          key: "in_weight",
          render: (value, original) => (
            <>
              <Tooltip triger='hover' title={"ประวัติน้ำหนักเข้า"}>
                <a onClick={() => setTargetInWeightLog({ id: original.id })}>
                  {formatComma(toFixed(value, 0))}
                </a>
              </Tooltip>
            </>
          ),
        },
      ],
    },
    {
      title: "ออก",
      children: [
        {
          title: "วัน - เวลา",
          dataIndex: "out_datetime",
          key: "out_datetime",
          render: (value, original) => {
            return (
              <center>
                <div>{value ? dateToHumanString(value) : "-"}</div>
                <div>{value ? timeToString(value) : ""}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "out_weight",
          key: "out_weight",
          render: (value, original) => (
            <>
              <Tooltip triger='hover' title={"ประวัติน้ำหนักออก"}>
                <a onClick={() => setTargetOutWeightLog({ id: original.id })}>
                  {formatComma(toFixed(value, 0))}
                </a>
              </Tooltip>
            </>            
          ),
        },
      ],
    },
    {
      title: 'น้ำหนักสุทธิ',
      dataIndex: 'net_weight',
      key: 'net_weight',
      render : (value) => <center>{formatComma(toFixed(value, 0))}</center>
    },
    {
      title: "Lot น้ำยางสด",
      dataIndex: "pond_input",
      key: "pond_input",
      render: (value, original) =>
        original.pond_input ? (
          <>
            <div>ล็อต : {_.get(original, "lot_no_input", "-")}</div>
            <div>บ่อ : {_.get(original, "pond_input", "-")}</div>
            <div>กระบะ : {_.get(original, "tray_input", "-")}</div>
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
    {
      title: 'น้ำหนักประมาณ',
      dataIndex: 'estimated_weight',
      key: 'estimated_weight',
      render : (value) => <center>{formatComma(toFixed(value, 0))}</center>
    },

  ];

  React.useEffect(() => {
    if(rangeDate.date_after){
     refreshData(rangeDate)
    } else {
      refreshData({date_after : "", date_before : ""})
    }
  },[rangeDate])

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ marginTop : 16 }}>
      <ErrorMessages message={errorMessage} />
      วันที่ : 
      <DatePicker.RangePicker
        style={{ marginBottom : 10, marginLeft : 10, marginRight : 20 }}
        onCalendarChange={(dates, dateStrings) => setRangeDate({date_after : dateStrings[0], date_before : dateStrings[1]})}
        defaultValue={[dayjs(), dayjs()]}
      />
      <SummaryWeightLatex/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_TRUCK.TRUCK_TRANSACTION}
        params={{...rangeDate}}
      />

      <ReceivingWeightLogModal
        open={targetInWeightLog ? true : false}
        target={targetInWeightLog}
        onClose={() => setTargetInWeightLog(null)}
        direction={"in"}
      />

      <ReceivingWeightLogModal
        open={targetOutWeightLog ? true : false}
        target={targetOutWeightLog}
        onClose={() => setTargetOutWeightLog(null)}
        direction={"out"}
      />
    </div>
  );
});

export default ReceivingLatexList;
